import { styled } from '@sans-souci/styles'

export const Form = styled('form', {
  display: 'grid',
  gap: '$32',
  gridAutoFlow: 'row',
})
